import { BaseEntity } from "./base.model";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import SentimentNeutralIcon from "@mui/icons-material/SentimentNeutral";
import { orange } from "@mui/material/colors";
import { Period } from "./report.model";

export enum SentimentEnum {
  positive = "positive",
  negative = "negative",
  neutral = "neutral",
}

export enum SentimentTypeEnum {
  all = "all",
  positive = "positive",
  negative = "negative",
  neutral = "neutral",
}

export interface Sentiment extends BaseEntity {
  id: string;
  submitId: string;
  questionKey: string;
  eventId: string;
  type: SentimentEnum;
  score: number;
  content: string;
  date: string;
  keywords: SentimentKeywordRaw[];
}

export interface SentimentKeywordRaw {
  text: string;
  sentiment: SentimentEnum;
  score: number;
}

export interface GetSentimentParam {
  id: string;
  period?: Period;
  search?: string;
}

export interface SentimentSummary {
  positive: number;
  negative: number;
  neutral: number,
  all: number;
}

export interface SentimentKeyword {
  label: string;
  sentimentSks: string[];
  positive: number;
  negative: number;
  neutral: number;
}

export const sentimentMap: { [key in SentimentEnum]: React.ReactNode } = {
  positive: <SentimentSatisfiedAltIcon color="success" />,
  negative: <SentimentVeryDissatisfiedIcon color="error" />,
  neutral: <SentimentNeutralIcon sx={{ color: orange[500] }} />,
};

export interface TextBubblePosition {
  left: number;
  width: number;
  top: number;
}

export interface TextBubbleAnalysis {
  keyword: SentimentKeyword;
  position: TextBubblePosition;
}

export type SentimentConfig = Record<
  string,
  {
    show?: boolean;
    label?: string;
    group?: string;
  }
>;

export const bubbleDataMap: TextBubblePosition[] = [
  {
    width: 9,
    left: 46,
    top: 33,
  },
  {
    width: 8,
    left: 0,
    top: 10,
  },
  {
    width: 7,
    left: 75,
    top: 8,
  },
  {
    width: 6,
    left: 24,
    top: 45,
  },
  {
    width: 5,
    left: 12,
    top: 70,
  },
  {
    width: 4,
    left: 45,
    top: 2,
  },
  {
    width: 4,
    left: 32,
    top: 24,
  },
  {
    width: 3,
    left: 65,
    top: 1,
  },
  {
    width: 3,
    left: 78,
    top: 68,
  },
  {
    width: 3,
    left: 39,
    top: 79,
  },
];
